<div class="wallboard-config-container">
  <form #wallboardConfig="ngForm">
    <fieldset>
      <h2>Site: {{activeConfig.Site}}</h2>

      <div class="uk-margin" *ngIf="!aggregate">
        <label class="uk-form-label rotationlabel">Refresh Interval</label>
        <input class="refresh-interval-slider" type="range" min="5" max="45" list="steplist" [(ngModel)]="wallboardService.activeQueueConfig.RotationDelay" name="rotationDelay">
        <datalist id="steplist">
          <option>5</option>
          <option>10</option>
          <option>15</option>
          <option>20</option>
          <option>25</option>
          <option>30</option>
          <option>35</option>
          <option>40</option>
          <option>45</option>
        </datalist>
        <app-time-display secondsOnly="true" [timeInSeconds]="wallboardService.activeQueueConfig.RotationDelay"></app-time-display>
      </div>

      <div class="uk-margin" *ngIf="!aggregate">
        <label class="uk-form-label rotationlabel">Announcements</label>
        <input type="text" [(ngModel)]="wallboardService.activeQueueConfig.Announcements">
      </div>

      <div class="uk-margin" *ngIf="aggregate">
        <label class="uk-form-label rotationlabel">Title</label>
        <input [ngClass]="[(activeConfig.Title.trim().length > 0) ? 'uk-input fullWidthInput' : 'uk-input fullWidthInput uk-form-danger']" type="text" [(ngModel)]="activeConfig.Title" name="panetitle" (ngModelChange)="validationChange.emit($event)">
      </div>

      <div class="uk-margin" *ngIf="aggregate">
        <label class="uk-form-label queueListLabel">Queue List</label>
        <mat-form-field>
          <label *ngIf="(activeConfig.QueueList.length == 0)" class='uk-form-danger'>Required</label>
          <mat-select multiple name="queueListSelect" [(ngModel)]="activeConfig.QueueList" (ngModelChange)="validationChange.emit($event)">
            <mat-select-trigger>
              {{activeConfig.QueueList.length}}
              {{(activeConfig.QueueList.length === 1) ? 'Queue Selected' : 'Queues Selected' }}
            </mat-select-trigger>
            <mat-option *ngFor="let queue of configService.queueNamesList" [value]="queue.queueConfig.arn">{{queue.queueName}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="uk-margin" *ngIf="activeConfig.AggregateView">
      </div>

      <br>
      <h3>Thresholds</h3>
      <div class="thresholdsContainer">
        <div class="uk-margin">
          <label class="uk-form-label">Abandoned Percentage</label>
          <div class="-collapse uk-child-width-expand@s" >
            <app-tethered-input 
              [(valueOne)]="activeConfig.Thresholds.yellow.ABN"
              labelOne="Yellow"
              [(valueTwo)]="activeConfig.Thresholds.red.ABN"
              labelTwo="Red">
            </app-tethered-input>
          </div>
        </div>

        <div class="uk-margin">
          <label class="uk-form-label">In Queue</label>
          <div class="-collapse uk-child-width-expand@s" >
            <app-tethered-input 
              [(valueOne)]="activeConfig.Thresholds.yellow['Queue']"
              labelOne="Yellow"
              [(valueTwo)]="activeConfig.Thresholds.red['Queue']"
              labelTwo="Red">
            </app-tethered-input>
          </div>
        </div>

        <div class="uk-margin">
          <label class="uk-form-label">Oldest (In Seconds)</label>
          <div class="-collapse uk-child-width-expand@s">
            <app-tethered-time-input 
              [(valueOne)]="activeConfig.Thresholds.yellow.Oldest"
              labelOne="Yellow"
              [(valueTwo)]="activeConfig.Thresholds.red.Oldest"
              labelTwo="Red">
            </app-tethered-time-input>
          </div>
        </div>

        <div class="uk-margin">
          <label class="uk-form-label">Average Queue Answer Time (In Seconds)</label>
            <div class="-collapse uk-child-width-expand@s">
            <app-tethered-time-input 
              [(valueOne)]="activeConfig.Thresholds.yellow['ASA']"
              labelOne="Yellow"
              [(valueTwo)]="activeConfig.Thresholds.red['ASA']"
              labelTwo="Red">
            </app-tethered-time-input>
          </div>
        </div>

      </div>
    </fieldset>
  </form>
</div>
